<div *ngIf="selectedTagDefinition" class="card mb-3">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h5 class="mb-0">Tag Definition Details</h5>
        <div *ngIf="selectedTagDefinition.id > 0" class="d-flex" style="gap: 8px;">
            <button class="btn btn-sm btn-warning" (click)="onEdit()">
                <i class="fa fa-edit"></i> Edit
            </button>
        </div>
    </div>
    <div class="card-body da-tag-management__details-body">
        <div class="row mb-2">
            <div class="col-md-4"><strong>Engineer Friendly Name:</strong></div>
            <div class="col-md-8">{{ selectedTagDefinition.engineerFriendlyName }}</div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><strong>Base Device Type:</strong></div>
            <div class="col-md-8">{{ selectedTagDefinition.baseDeviceTypeName || '-' }}</div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><strong>Data Type:</strong></div>
            <div class="col-md-8">{{ selectedTagDefinition.dataType || '-' }}</div>
        </div>
        <div class="row mb-2">
            <div class="col-md-4"><strong>Default Value:</strong></div>
            <div class="col-md-8">{{ selectedTagDefinition.defaultValue || '-' }}</div>
        </div>
    </div>
</div>
